(function (window, document) {
    'use strict';

    function getRoot() {
        return document.querySelector('[data-free-bouquets-page-root]');
    }

    function getGrid() {
        return document.querySelector('[data-free-bouquets-grid]');
    }

    function getPaginationRoot() {
        return document.querySelector('[data-free-bouquets-pagination]');
    }

    function getPageSize() {
        const root = getRoot();
        return Number(root && root.dataset.pageSize ? root.dataset.pageSize : 48);
    }

    function waitForCore(callback) {
        if (window.FreeBouquetsCore) {
            callback();
            return;
        }

        window.addEventListener('FreeBouquetsCore:ready', function onReady() {
            window.removeEventListener('FreeBouquetsCore:ready', onReady);
            callback();
        });
    }

    function productCardHTML(product, FBC) {
        const imageSrc = product.featured_image && product.featured_image.src
            ? product.featured_image.src
            : '';

        const imageAlt = product.featured_image && product.featured_image.alt
            ? product.featured_image.alt
            : product.title;

        const variantId = FBC.getProductVariantId(product);
        const regularPrice = Number(product.price_min || 0);

        return [
            '<div class="one-fourth medium-down--one-half small-down--one-half column has-thumbnail-sticker thumbnail product__thumbnail product__grid-item thumbnail__hover-overlay--false" ',
            'data-product-id="', FBC.escapeHtml(product.id), '" ',
            'data-product-handle="', FBC.escapeHtml(product.handle), '" ',
            'data-bouquet-min-price="', FBC.escapeHtml(product.price_min), '">',

            '<div class="product-wrap">',

            '<div class="product-image__wrapper">',
            '<div class="image__container product__imageContainer">',
            imageSrc
                ? [
                    '<img ',
                    'src="', FBC.escapeHtml(imageSrc), '" ',
                    'alt="', FBC.escapeHtml(imageAlt), '" ',
                    'width="250" ',
                    'height="250" ',
                    'loading="lazy" ',
                    'decoding="async">'
                ].join('')
                : '<div class="free-bouquets-card__placeholder"></div>',
            '</div>',
            '</div>',

            '<div class="thumbnail__caption">',
            '<div class="product-thumbnail free-bouquet">',
            product.delivery_pill || '',
            '<span class="product-thumbnail__title">', FBC.escapeHtml(product.title), '</span>',

            '<form action="/cart/add" method="post" class="fsw-form" id="free-bouquet-form-', FBC.escapeHtml(product.id), '">',
            '<input type="hidden" name="id" value="', FBC.escapeHtml(variantId), '">',
            '<input type="hidden" name="quantity" value="1">',

            '<div class="fsw-bottom">',
            '<div class="fsw-price-wrap">',
            '<span class="product-thumbnail__price product-thumbnail__price--current">£ 0</span>',

            '<span class="product-thumbnail__was-price compare-at-price">',
            '<span class="money">', FBC.formatMoney(regularPrice), '</span>',
            '</span>',
            '</div>',

            '<button type="submit" class="fsw-cta fsw-cta--button">Order</button>',
            '</div>',
            '</form>',
            '</div>',
            '</div>',

            '</div>',
            '</div>'
        ].join('');
    }

    function renderPagination(totalPages, currentPage, cards, FBC, renderPage) {
        const paginationRoot = getPaginationRoot();

        if (!paginationRoot) return;

        if (totalPages <= 1) {
            paginationRoot.innerHTML = '';
            return;
        }

        let html = '';

        html += '<div class="paginate" data-current-page="' + currentPage + '" data-paginate-pages="' + totalPages + '">';
        html += '<nav class="pagination ' + ((currentPage > 1 && currentPage < totalPages) ? 'paginate--both' : '') + '" role="navigation" aria-label="pagination">';

        if (currentPage > 1) {
            html += '<a href="#" class="pagination-previous" data-page="' + (currentPage - 1) + '">Previous</a>';
        }

        html += '<ul class="pagination-list">';

        for (let i = 1; i <= totalPages; i++) {
            if (i === currentPage) {
                html += '<li><a class="pagination-link is-current">' + i + '</a></li>';
            } else {
                html += '<li><a href="#" class="pagination-link" data-page="' + i + '">' + i + '</a></li>';
            }
        }

        html += '</ul>';

        if (currentPage < totalPages) {
            html += '<a href="#" class="pagination-next" data-page="' + (currentPage + 1) + '">Next</a>';
        }

        html += '</nav>';
        html += '</div>';

        paginationRoot.innerHTML = html;

        paginationRoot.querySelectorAll('[data-page]').forEach(function (link) {
            link.addEventListener('click', function (e) {
                e.preventDefault();

                const page = parseInt(link.getAttribute('data-page'), 10);
                renderPage(cards, page);

                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        });
    }

    function bindPageForms(FBC) {
        FBC.bindFreeBouquetForms('.fsw-form', {
            deliveryVariantId: '52824633213256',
            redirectUrl: '/checkout'
        });
    }

    function init() {
        const root = getRoot();
        const grid = getGrid();
        const pagination = getPaginationRoot();

        if (!root || !grid || !pagination) return;

        const FBC = window.FreeBouquetsCore;
        const data = window.FreeBouquets || {};
        const PAGE_SIZE = getPageSize();

        if (!data.customer) {
            window.location.href = '/';
            return;
        }

        const reward = FBC.getRewardState(data.orders || []);

        if (!reward.isUnlocked) {
            window.location.href = '/';
            return;
        }

        const renderPage = function (cards, page) {
            const totalPages = Math.max(1, Math.ceil(cards.length / PAGE_SIZE));
            const currentPage = Math.max(1, Math.min(page, totalPages));

            const startIndex = (currentPage - 1) * PAGE_SIZE;
            const pageCards = cards.slice(startIndex, startIndex + PAGE_SIZE);

            grid.innerHTML = pageCards.map(function (product) {
                return productCardHTML(product, FBC);
            }).join('');

            renderPagination(totalPages, currentPage, cards, FBC, renderPage);
            bindPageForms(FBC);
        };

        FBC.loadCollectionData({
            collectionHandle: 'free-bouquets',
            view: 'free-bouquets-json',
            page: 1,
            allPages: true
        }).then(function (collectionData) {
            const allProducts = (collectionData.products || []).filter(function (product) {
                return Number(product.price_min || 0) > 0;
            });

            let filtered = FBC.filterProductsByReward(allProducts, reward);

            if (filtered.length === 0) {
                filtered = allProducts
                    .sort(function (a, b) {
                        return Number(a.price_min || 0) - Number(b.price_min || 0);
                    })
                    .slice(0, PAGE_SIZE);
            }

            renderPage(filtered, 1);
        }).catch(function (err) {
            console.error(err);
            grid.innerHTML = '<p class="collection__error">Something went wrong. Please try again.</p>';
        });
    }

    function start() {
        waitForCore(init);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }

    document.addEventListener('shopify:section:load', function (event) {
        const root = getRoot();

        if (!root) return;

        if (event && event.detail && event.detail.sectionId) {
            const sectionId = root.dataset.sectionId;

            if (sectionId && event.detail.sectionId !== sectionId) {
                return;
            }
        }

        start();
    });
})(window, document);